import React, { useState } from 'react';
import data from '../../../utils/tabsData.json';
import MobileWatch from '../../../assets/mobile_watch.svg';
import WatchPage from '../../productDetail/WatchPage';
import './Collections.css';
import { useNavigate } from 'react-router-dom';
import { useFillLastRowWithDuplicates } from '../../../hooks/useFillLastRowWithDuplicates';

interface CollectionsProps {
  activeTab: string | null;
  activeSubTab: string | null;
  setShowBackground: (show: boolean) => void;
  setActiveTab: (tabId: string | null) => void;
  setActiveSubTabs: (subTabs: any[]) => void;
  // Enable smart duplication to fill the last row
  fillIncompleteLastRow?: boolean;
}

const Collections: React.FC<CollectionsProps> = ({
  activeTab,
  activeSubTab,
  setActiveTab,
  setActiveSubTabs,
  setShowBackground,
  fillIncompleteLastRow = false,
}) => {
  const [activeProduct, setActiveProduct] = useState<string | null>(null);
  const navigate = useNavigate();
  const activeTabData = data.tabs.find((tab) => tab.id === activeTab);
  const subTabData = activeTabData?.subtabs.find((subtab) => subtab.id === activeSubTab);
  const products = subTabData?.products ?? [];
  const { containerRef, items: displayProducts } = useFillLastRowWithDuplicates(
    products,
    {
      enable: fillIncompleteLastRow,
      minItems: 11, // strictly more than 10
      itemSelector: '.product-box-container',
      offsetPercent: 0.2, // 20% offset into the list
      randomizeSelection: fillIncompleteLastRow,
    }
  );

  if (!activeTabData || !subTabData) return null;

  const handleProductClick = (productId: string) => {
    setShowBackground(true);
    setActiveTab(null);
    navigate(`/watches/${productId}`)
  };

  return (
    <div className="collections-container">
      {displayProducts && (
        <div className="product-design-boxes" ref={containerRef}>
          {displayProducts.map((product, idx) => (
            <div key={`${product.id}-${idx}`} className="product-box-container">
              <div
                className="product-box"
                onClick={() => handleProductClick(product.id)}
                style={{
                  backgroundImage: product.image ? `url(${MobileWatch})` : 'none',
                  backgroundColor: product.image ? 'transparent' : '#42424233',
                }}
              ></div>
              <p className="product-label">{product.label.en}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Collections;
